import axios from "axios";

export async function updateTargetGroup(id, data) {
    try {
        const response = await axios.patch(`/targetGroups/update/${id}`, data);
        return response.data.group;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка обновления группы";
        throw new Error(text);
    }
}
